// extracted by mini-css-extract-plugin
export default {"sliderContainer":"zlzJS2qChB"};